import React from 'react'
import { IconFileDownload } from '@tabler/icons-react'

import Typography, {
  TypographyTag,
  TypographyVariant,
} from '~/components/Typography'
import { ProductDownloadsProps } from './ProductDetails.types'

const ProductDownloads = ({ items }: ProductDownloadsProps) => {
  return (
    <div className='flex flex-col gap-4'>
      {items?.map((item) => {
        if (item.link) {
          return (
            <a
              key={item.title}
              href={item.link}
              download
              target='_blank'
              rel='noreferrer'>
              <div className='flex gap-2'>
                <IconFileDownload
                  size={24}
                  color='var(--color-state-success-light)'
                />
                <Typography
                  variant={TypographyVariant.BodyLarge}
                  tag={TypographyTag.span}
                  className='!underline text-secondary-muted'>
                  {item.title}
                </Typography>
              </div>
            </a>
          )
        }
        return null
      })}
    </div>
  )
}

export default ProductDownloads
